import { render, staticRenderFns } from "./addresolution.vue?vue&type=template&id=2ef875de&scoped=true&"
import script from "./addresolution.vue?vue&type=script&lang=js&"
export * from "./addresolution.vue?vue&type=script&lang=js&"
import style0 from "./addresolution.vue?vue&type=style&index=0&id=2ef875de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef875de",
  null
  
)

export default component.exports